import {Drawer, Button, Radio, Stack} from '@mantine/core';
import {Formik, Form} from 'formik';
import {useTags} from '../../tags/hooks/useTags';
import {Tag} from '../../tags/types';

interface TagMultipleDrawerProps {
    opened: boolean;
    onClose: () => void;
    onSubmit: (tagId: string) => void;
}

export const TagMultipleDrawer = ({opened, onClose, onSubmit}: TagMultipleDrawerProps) => {
    const {items: tags} = useTags();

    const handleSubmit = (values: {tagId: string}) => {
        onSubmit(values.tagId);
        onClose();
    };

    return (
        <Drawer opened={opened} onClose={onClose} title="Tag Multiple Messages" position="right">
            <Formik
                initialValues={{tagId: ''}}
                onSubmit={handleSubmit}
            >
                {({values, setFieldValue, submitForm}) => (
                    <Form>
                        <Stack>
                            <Radio.Group
                                label="Select a tag"
                                value={values.tagId}
                                onChange={(value) => setFieldValue('tagId', value)}
                            >
                                <Stack mt="xs">
                                    {tags.map((tag: Tag) => (
                                        <Radio key={tag.id} value={tag.id} label={tag.name} />
                                    ))}
                                </Stack>
                            </Radio.Group>
                            <Button type="button" onClick={submitForm} disabled={!values.tagId}>
                                Apply Tag
                            </Button>
                        </Stack>
                    </Form>
                )}
            </Formik>
        </Drawer>
    );
};
